import { Theme, css } from '@emotion/react';
import styled from '@emotion/styled';
import { ColorType } from './Checkbox';

const getActiveCheckColor = (colorType: ColorType, theme: Theme) => {
  switch (colorType) {
    case 'blue':
      return theme.content.hierarchy1;
    case 'basic':
      return theme.content.hierarchy1_reverse;
    case 'brand':
    default:
      return theme.always.label_white;
  }
};

const getActiveColor = (colorType: ColorType, theme: Theme) => {
  switch (colorType) {
    case 'blue':
      return theme.themeColor.main_1;
    case 'basic':
      return theme.content.hierarchy1;
    case 'brand':
      return theme.themeColor.brand;
    default:
      return theme.themeColor.brand;
  }
};

export const Container = styled.div<{ colorType: ColorType }>`
  ${({ theme, colorType }) => css`
    display: flex;
    align-items: center;

    > input {
      background: transparent;
      -webkit-appearance: none;
      -moz-appearance: none;
      -ms-appearance: none;
      appearance: none;
    }

    > input:checked + label > span {
      border: 1px solid
        ${colorType === 'blue' ? theme.themeColor.main_1 : 'transparent'};
      background: ${getActiveColor(colorType, theme)};
      ${colorType === 'blue' &&
      css`
        color: ${theme.content.content_dark_1};
      `}

      & > i {
        opacity: 1;
      }
    }
  `}
`;

export const CheckWrap = styled.label<{ colorType: ColorType }>`
  ${({ theme, colorType }) => css`
    display: inline-flex;
    position: relative;
    align-items: center;
    cursor: pointer;
    gap: 10px;

    &:hover {
      span {
        border: 1px solid ${getActiveColor(colorType, theme)};
      }
    }
  `}
`;

export const CheckIcon = styled.span<{ colorType: ColorType }>`
  ${({ theme, colorType }) => css`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border: 1px solid #fff;
    border-radius: 4px;
    color: ${getActiveCheckColor(colorType, theme)};

    & > i {
      opacity: 0;
    }
  `}
`;

export const Label = styled.p`
  ${({ theme }) => css`
    display: block;
    color: ${theme.themeColor.basic_dark};
    line-height: 1.2;
  `}
`;
